import React, { useState, useEffect, useRef } from 'react';
import TextTransition, { presets } from 'react-text-transition';
import styles from "./menu.module.css";
import 'animate.css';
//icons
import { FaHome, FaFolder, FaChevronDown, FaBook, FaUserFriends, FaChevronUp, FaSignOutAlt, FaCalendar, FaBrain, FaBriefcaseMedical, FaNotesMedical, FaAngleRight, FaMoneyBill, FaFileInvoiceDollar, FaUserTie, FaMapMarkedAlt } from "react-icons/fa";
import { FaGear } from "react-icons/fa6";
import { MdStorage } from 'react-icons/md';
import { LuLogs } from "react-icons/lu";
import { BsFillFileEarmarkBarGraphFill } from "react-icons/bs";
import { useAuth } from '../context/AuthContext';
import { PiNewspaperClippingFill, PiNoteFill } from 'react-icons/pi';
import { RiFileInfoFill, RiTableView } from 'react-icons/ri';
import { GrNotes } from 'react-icons/gr';
import { Title } from 'chart.js';
import WindowLayout from '../utils/layout/windowsLayout';
import { LuTicket } from 'react-icons/lu';


//

export default function MenuTarget(props) {
    const { setMenuActual, menuActual, windowSize, permisos } = useAuth();
    const [menuFront, setMenuFront] = useState([]);
    const [menuOptions, setMenuOptions] = useState([]);
    const [title, setTitle] = useState("");

    useEffect(() => {
        if (menuOptions && menuOptions != null && menuOptions.length > 0) {
            let array = [];
            for (let index = 0; index < menuOptions.length; index++) {
                const element = menuOptions[index];
                array.push(
                    <div className={styles.itemMenuContainer}>
                        <div id={"menu" + index} className={styles.itemMenuTarget} onClick={() => setMenuActual(element.menu)}>
                            <div className={styles.iconMenuTarget}>
                                {element.icon != null ? element.icon : <FaFolder />}
                            </div>
                            <div className={styles.textMenuTarget}>
                                <h6>{element.title}</h6>
                                <div>{element.content}</div>
                            </div>
                            <div className={styles.iconMenuTarget2}>
                                <FaAngleRight />
                            </div>
                        </div>
                    </div>
                );
            }
            setMenuFront(array);
        }
    }, [menuOptions, setMenuActual])
    useEffect(() => {
        if (menuActual === "configMenu") {
            setTitle("Configuración");
            let array = [];
            if (permisos.findIndex(item => item.identifier === "ConfigUsers") !== -1)
                array.push({
                    title: "Usuarios",
                    content: "Alta de usuarios.",
                    menu: "config1",
                    icon: <FaUserFriends />
                });
            if (permisos.findIndex(item => item.identifier === "ConfigPermissions") !== -1)
                array.push({
                    title: "Permisos",
                    content: "Administración de permisos.",
                    menu: "config2",
                    icon: <FaGear />
                });
            setMenuOptions(array);
        }
        else if (menuActual === "catalogMenu") {
            setTitle("Catalógos");
            let array = [];
            if (permisos.findIndex(item => item.identifier === "CatAse") !== -1)
                array.push({
                    title: "Asesores",
                    content: "Alta de asesores.",
                    menu: "catalog1",
                    icon: <FaUserTie />
                });
            if (permisos.findIndex(item => item.identifier === "CatAval") !== -1)
                array.push({
                    title: "Avales",
                    content: "Alta de avales.",
                    menu: "catalog2",
                    icon: <FaUserFriends />
                });
            if (permisos.findIndex(item => item.identifier === "CatCoor") !== -1)
                array.push({
                    title: "Coordinadores",
                    content: "Alta de coordinadores.",
                    menu: "catalog3",
                    icon: <FaUserTie />
                });
            if (permisos.findIndex(item => item.identifier === "CatDist") !== -1)
                array.push({
                    title: "Distribuidores",
                    content: "Alta de distribuidores.",
                    menu: "catalog4",
                    icon: <FaAngleRight />
                });
            if (permisos.findIndex(item => item.identifier === "CatEmp") !== -1)
                array.push({
                    title: "Empresas",
                    content: "Alta de empresas.",
                    menu: "catalog5",
                    icon: <FaFolder />
                });
            if (permisos.findIndex(item => item.identifier === "CatEmpAfi") !== -1)
                array.push({
                    title: "Empresas Afiliadas",
                    content: "Alta de empresas afiliadas.",
                    menu: "catalog6",
                    icon: <FaFolder />
                });
            if (permisos.findIndex(item => item.identifier === "CatSuc") !== -1)
                array.push({
                    title: "Sucursales",
                    content: "Alta de sucursales.",
                    menu: "catalog7",
                    icon: <FaHome />
                });
            if (permisos.findIndex(item => item.identifier === "CatHoli") !== -1)
                array.push({
                    title: "Dias Festivos",
                    content: "Alta de dias festivos.",
                    menu: "catalog8",
                    icon: <FaCalendar />
                });



            array = [...array].sort((a, b) => a.title.localeCompare(b.title))
            setMenuOptions(array);
        }
        else if (menuActual === "prestamoMenu") {
            setTitle("Préstamos");
            let array = [];
            if (permisos.findIndex(item => item.identifier === "Client") !== -1)
                array.push({
                    title: "Clientes",
                    content: "Alta de clientes.",
                    menu: "prestamo1",
                    icon: <FaUserFriends />
                });
            // Metas
            if (permisos.findIndex(item => item.identifier === "MetAse") !== -1)
                array.push({
                    id: "prestamo4",
                    title: "Metas",
                    content: "Gestión de metas asesores.",
                    menu: "prestamo4",
                    icon: <PiNewspaperClippingFill />
                });
            if (permisos.findIndex(item => item.identifier === "Prest") !== -1)
                array.push({
                    title: "Prestamos",
                    content: "Gestión de prestamos.",
                    menu: "prestamo3",
                    icon: <RiTableView />
                });
            if (permisos.findIndex(item => item.identifier === "Nomina") !== -1)
                array.push({
                    title: "Nomina Asesores",
                    content: "Gestión de nómina de asesores.",
                    menu: "prestamo5",
                    icon: <FaMoneyBill />
                });
            setMenuOptions(array);
        }
        else if (menuActual === "homeMenu") {
            setTitle("Inicio");
            let array = [];
            // Catálogos
            if (permisos.findIndex(item => item.identifier.startsWith("Cat")) !== -1) {
                array.push({
                    id: "catalogMenu",
                    title: "Catálogos",
                    content: "Gestión de catálogos.",
                    menu: "catalogMenu",
                    icon: <MdStorage />
                });
            }
            // Clientes
            if (permisos.findIndex(item => item.identifier === "Client") !== -1) {
                array.push({
                    title: "Clientes",
                    content: "Alta de clientes.",
                    menu: "prestamo1",
                    icon: <FaUserFriends />
                });
            }
            // Configuración
            if (permisos.findIndex(item => item.identifier.startsWith("Config")) !== -1) {
                array.push({
                    id: "configMenu",
                    title: "Configuración",
                    content: "Configuración del sistema.",
                    menu: "configMenu",
                    icon: <FaGear />
                });
            }
            // Corte de Caja
            if (permisos.findIndex(item => item.identifier === "CorteCaja") !== -1) {
                array.push({
                    id: "corte",
                    title: "Corte de Caja",
                    content: "Gestión de cortes de caja.",
                    menu: "corte",
                    icon: <FaFileInvoiceDollar />
                });
            }
            if (permisos.findIndex(item => item.identifier === "Reports") !== -1) {
                array.push({
                    id: "reportes",
                    title: "Reportes",
                    content: "Visualización de graficas y descarga de reportes",
                    menu: "reportes",
                    icon: <FaFileInvoiceDollar />
                });
            }
            if (permisos.findIndex(item => item.identifier === "AuditLog") !== -1) {
                array.push({
                    id: "auditlog",
                    title: "Log de Auditoria",
                    content: "Visualización de logs de auditoria",
                    menu: "auditlog",
                    icon: <LuLogs />
                });
            }
            // Documentación
            array.push({
                id: "document",
                title: "Documentación",
                content: "Gestión de documentación.",
                menu: "document",
                icon: <FaBook />
            });
            // Rutas
            // array.push({
            //     id: "rutas",
            //     title: "Rutas",
            //     content: "Mapa y cálculo de ruta optimizada.",
            //     menu: "rutas",
            //     icon: <FaMapMarkedAlt />
            // });
            // Metas
            if (permisos.findIndex(item => item.identifier === "MetAse") !== -1) {
                array.push({
                    id: "prestamo4",
                    title: "Metas",
                    content: "Gestión de metas asesores.",
                    menu: "prestamo4",
                    icon: <PiNewspaperClippingFill />
                });
            }
            // Nómina Asesores
            if (permisos.findIndex(item => item.identifier === "Nomina") !== -1) {
                array.push({
                    id: "prestamo5",
                    title: "Nómina Asesores",
                    content: "Gestión de nómina de asesores.",
                    menu: "prestamo5",
                    icon: <FaMoneyBill />
                });
            }
            // Pagos
            if (permisos.findIndex(item => item.identifier === "Pag") !== -1) {
                array.push({
                    id: "pagos",
                    title: "Pagos",
                    content: "Gestión de pagos para asesores.",
                    menu: "pagos",
                    icon: <FaMoneyBill />
                });
            }
            // Préstamos
            if (permisos.findIndex(item => item.identifier === "Prest") !== -1) {
                array.push({
                    id: "prestamo3",
                    title: "Préstamos",
                    content: "Gestión de prestamos.",
                    menu: "prestamo3",
                    icon: <RiTableView />
                });
            }
            // Vales
            if (permisos.findIndex(item => item.identifier.includes("Vale")) !== -1) {
                array.push({
                    id: "vales",
                    title: "Vales",
                    content: "Gestión de vales.",
                    menu: "vales",
                    icon: <LuTicket />
                });
            }
            if (permisos.findIndex(item => item.identifier === "Reportes") !== -1) {
                array.push({
                    id: "reportes",
                    title: "Reportes",
                    content: "Reportes",
                    menu: "reportes",
                    icon: <FaFileInvoiceDollar />
                });
            }

            setMenuOptions(array);
        }
    }, [menuActual]);

    return (
        <>
            <WindowLayout
                title={title}
                route={menuActual !== "homeMenu" ? ["Inicio", title] : ["Inicio"]}
                actions={[() => setMenuActual("homeMenu"), () => { }]}
                icon={<FaHome />}
            >
                <div className=''>

                    <div className={styles.containerMenuTarget}>

                        {menuFront}
                    </div>

                </div>
            </WindowLayout>
        </>
    )
}